export enum TicketUsageStatus {
  USED = 'USED',
  NOT_USED = 'NOT_USED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED'
}
